<template>
  <CommonPages id="home" classs="home novall">
    <div v-if="recommondList && recommondList.length >0" class="recommand-row ">
      <!-- <AdComponent ref="ads-home-1" class="content ad-width-padding" :ads="adsensConfig?.home_1"
      :showDebug="showDebug" /> -->
      <swiper ref="swiperbanner" class="swiper pc_padding" :options="swiperbannerOption">
        <swiper-slide v-for="(data,i) in recommondList" :key="`recommen_${i}`"
          class="swiper-banner-container">
          <div class="recommand-banner-row cursor"
            @click="chooseNoval(data.novelId,data.id,data.novelName)">
            <div class="recommand-banner-shadow" />
            <img v-lazy="data.bigImg" class="recommand-banner-img" alt="">
            <div class="recomannd-banner-rate-info-row">
              <div class="recomannd-banner-rate-info-tag">
                <div class="recomannd-banner-rate-info-tag-item" v-html="data.novelType" />
              </div>
              <div class="recomannd-banner-rate-info-stars-row">
                <img src="@/assets/star.png" alt=""> {{ data.novelScore }}/10
              </div>
            </div>
          </div>
          <div class="recommand-intro-row cursor"
            @click="chooseNoval(data.novelId,data.id,data.novelName)">
            <div class="recommand-title">
              {{ data.novelName }}
            </div>
            <div class="recommand-author">
              {{ data.novelAuthorName }}
            </div>

            <AdComponent v-if="deviceType == 'mobile'" ref="ads-home-1"
            class="content ad-content-full " :ads="adsensConfig?.home_1" :showDebug="showDebug" />

            <div class="recommand-content" v-html="data.novelStoryIntro" />
            <div class="recommand-btn cursor">
              Read Now
            </div>
          </div>
        </swiper-slide>
        <div v-if="deviceType != 'mobile'" slot="button-prev" class="swiper-button-prev" />
        <div v-if="deviceType != 'mobile'" slot="button-next" class="swiper-button-next" />

        <div slot="pagination" class="swiper-pagination" />
      </swiper>
    </div>

    <!-- <AdComponent ref="ads-home-2" class="m-b-40 content pc_padding" :ads="adsensConfig?.home_2"
      :showDebug="showDebug" /> -->

    <div class="site-intro-container pc_padding">
      <div class="site-title">
        Discover endless creativity with AI-generated novels
      </div>
      <div class="site-content m-t-30 m-b-30">
        Immerse yourself in the fantastical world of AI creatio ns and explore endless stories with
        like-minded read ers.
      </div>
    </div>

    <div class="intro-swiper-container pc_padding">
      <swiper ref="introSwiper" class="intro-swiper" :options="swiperOption">
        <swiper-slide v-for="(data, index) in introSource" :key="index" class="intro-swiper-item">
          <img :src="data.img" alt="" class="intro-swiper-img">
          <div class="intro-swiper-title" v-html="data.title" />
          <div class="intro-swiper-content" v-html="data.content" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="library-container pc_padding">
      <div class="site-title m-b-30">
        Library
      </div>
      <div class="library-tag-row">
        <div v-for="(data,i) in tagList" :key="`tag_${i}`" class="library-tag-item cursor"
          :class="{'active':activeTag == data}" @click="seclecTag(data)">
          {{ data }}
        </div>
      </div>

      <div class="library-row pc_padding">
        <template v-for="(data,i) in novelList">
          <div :key="`lib-${i}`" class="library-item cursor"
            @click="chooseNoval(data.novelId,data.id,data.novelName)">
            <div class="library-item-img-row">
              <div class="library-item-img-shadow" />
              <img v-lazy="data.bigImg" class="library-item-img" alt="">
              <div class="library-item-info-stars-row">
                <img src="@/assets/star.png" alt=""> {{ data.novelScore }}/10
              </div>
            </div>
            <div class="library-item-info-row">
              <div class="library-item-title" v-html="data.novelName" />
              <div class="library-item-autor" v-html="data.novelAuthorName" />
            </div>
            <div class="library-item-type">
              <div class="library-type" v-html="data.novelType" />
            </div>
          </div>
          <!-- 插入广告 -->
          <div v-if="shouldInsertAd(i) !== -1" :key="`ad_${i}`" class="ad-width-100 ad-pos-row">
            <AdComponent v-if="adsensConfig?.home_recommand?.[shouldInsertAd(i)]" :ref="'ads-' + i"
              class="recommand-ads" :ads="adsensConfig?.home_recommand[shouldInsertAd(i)]"
              :showDebug="showDebug" />
          </div>
        </template>
      </div>
    </div>

    <div v-if="domainConfig?.anchor" class="anchor-txt" v-html="domainConfig?.anchor" />
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js';
import adMixin from '@/mixin/adMixin.js';
import adTrackingMixin from '@/mixin/adTrackingMixin.js';
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import CommonPages from '@/pages/components/pc_common.vue'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import '@/css/common.scss';

export default {
  name: 'Home',
  components: {
    AdComponent,
    CommonPages,
    Swiper,
    SwiperSlide
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      swiperbannerOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOption: {
        direction: 'horizontal',
        slidesPerView: "auto",
        centeredSlides: true,// 居中的slide是否标记为active，默认是最左active,这样样式即可生效
        loop: true, // 开启无限循环
      },
      introSource: [
        { img: require('@/assets/icon_1.png'), title: 'Unlimited Creative Source', content: 'Users can upload and create AI-generated novels, exploring endless creativity and storylines.' },
        { img: require('@/assets/icon-2.png'), title: 'Diverse Genre Exploration', content: 'We offer a wide range of genres, allowing users to explore and enjoy various types of stories, from science fiction to romance.' },
        { img: require('@/assets/icon-3.png'), title: 'Enjoy instant updates', content: 'Reading the latest AI-generated stories as soon as they are available, so you never miss out on exciting content.' },
      ],

      // novelList: [],
      // tagList: null,
      // recommondList: [],
      // hasNext: false,

      page: 1,   // 当前页数
      activeTag: null,

      ////////
    };
  },
  metaInfo () {
    return {
      title: `${this.domainConfig["IAmURL"]} - AI-Generated Novels and Stories`,
      meta: [
        {
          name: 'description',
          content: `Discover a world of AI-generated novels and stories at ${this.domainConfig["IAmURL"]}. Dive into unique, imaginative tales created by advanced artificial intelligence. Perfect for readers seeking fresh and innovative content.`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      "domainConfig",
      "recommondList",
      "tagList",
      "novelList",
      "hasNext"
    ])
  },
  async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
  async mounted () {
    console.log(`-------------------${this.$options.name} mounted`)

    if (!this.recommondList.length) {
      this.getRecommand()
    }
    if (!this.tagList.length) {
      this.getTagList()
    }
    if (!this.novelList.length) {
      await this.getPageList()
    }

    // 使用防抖包装滚动事件
    this.onScroll = this.debounce(this.onScroll.bind(this), 300);
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll);

    // 在页面ready后执行showPos方法
    this.$nextTick(() => {
      setTimeout(() => {
        this.showPos();
      }, 1000); // 延迟1秒执行，确保页面元素已完全加载
    });
  },
  deactivated () {
    console.log(`${this.$options.name} Component deactivated-----------`);
  },
  beforeDestroy () {
    console.log(`-------------------${this.$options.name} beforeDestroy`);
    // 组件销毁时移除滚动事件监听
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    //shuju
    async getRecommand () {
      try {
        const res = await this.$global.server.getRecommand({ noveLang: 'en' })
        console.log(res)
        if (res.code == 200) {
          let data = res.data.novelList
          this.recommondList.push(...data)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getTagList () {
      try {
        const res = await this.$global.server.getTagList({ noveLang: 'en' })
        console.log(res)
        this.tagList = res.data

      } catch (err) {
        console.log(err)
      }
    },
    async getPageList () {
      const params = {
        novelLang: 'en',
        pageNum: this.page,
        pageSize: 30,
      };
      // 只有当 this.tag 不为 null 时，才添加 tag 字段
      if (this.activeTag !== null) {
        params.novelType = this.activeTag;
      }

      try {
        const res = await this.$global.server.getPageList(params)
        console.log(res)
        if (res.code == 200) {
          let data = res.data.novelList
          this.novelList.push(...data)
          this.hasNext = res.data.hasNext
          this.page++;
        }
      } catch (err) {
        console.log(err)
      }
    },
    seclecTag (tag) {
      if (this.activeTag == tag) return
      console.log(tag);
      this.activeTag = tag
      this.page = 1;   // 当前页数
      this.hasNext = false;
      console.log('清空前:', this.novelList.length);

      // 方法1：使用数组length清空
      this.novelList.length = 0;

      // 或者方法2：使用Vue.set
      // this.$set(this, 'novelList', []);

      // 使用nextTick确保DOM更新后再查看结果
      this.$nextTick(() => {
        console.log('清空后:', this.novelList.length);
      });

      this.getPageList()

      // this.getPageList()
    },
    chooseNoval (name, id) {
      console.log(name, id);
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${name}/${id}/0${fullQueryString}`;

      // window.location.href = `/${name}/${id}/0`
    },
    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    onScroll () {
      // 获取文档的总高度
      const documentHeight = document.documentElement.scrollHeight;
      // 当前滚动的高度
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // 视口的高度
      const windowHeight = window.innerHeight;

      // 在滚动时执行 showPos 方法，获取当前可视范围内的广告坐标
      this.showPos();

      // 当滚动距离接近底部2000px时触发
      if (scrollTop + windowHeight >= documentHeight - 2000) {
        console.log('加载');
        this.getPageList();
      }
    },
    //广告相关start
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.deviceType == 'mobile' ? this.adPosConfig.homeRecommand.indexOf(position) : this.adPosConfig.homeRecommandPC.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    shouldDetailInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.detail.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },

    //广告相关end

    //ciyi

    goto (name) {
      this.$router.push({ name: name });
    },

    // 显示当前屏幕可视范围内的广告坐标
    showPos () {
      console.log('执行showPos方法，显示当前可视范围内的广告坐标');

      // 获取所有广告元素 (AdX / GPT)
      const adElements = document.querySelectorAll('.gpt-ad');
      const visibleAds = [];

      // 当前屏幕可视区域信息
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // 遍历所有广告元素，找出在可视范围内的
      adElements.forEach((adElement, index) => {
        // 使用 getBoundingClientRect 获取元素相对于视口的位置
        const rect = adElement.getBoundingClientRect();

        // 检查元素是否在视口中可见（至少部分可见）
        // rect.top 和 rect.left 是相对于视口左上角的坐标
        const isVisible = !(
          rect.bottom < 0 ||   // 元素底部在视口顶部以上
          rect.top > windowHeight ||  // 元素顶部在视口底部以下
          rect.right < 0 ||  // 元素右侧在视口左侧以外
          rect.left > windowWidth  // 元素左侧在视口右侧以外
        );

        if (isVisible) {
          // 保持与 setupIframeTracking 方法中相同的数据格式
          const transformData = {
            insX: Math.round(rect.left),
            insY: Math.round(rect.top),
            insHeight: Math.round(rect.height),
            windowWidth: windowWidth,
            windowHeight: windowHeight
          };

          visibleAds.push(transformData);
          console.log(`可视广告 #${index}:`, transformData);
        }
      });

      console.log('可视范围内的广告数量:', visibleAds.length);
      console.log('可视范围内的广告坐标:', visibleAds);

      // 即使没有可见广告，也会发送空数组
      this.$adPosition(JSON.stringify(visibleAds))
      return visibleAds;
    },

    // 计算元素在视口中的可见比例
    calculateVisibility (rect, windowWidth, windowHeight) {
      // 计算元素在视口内可见部分的面积
      const visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      if (visibleWidth <= 0 || visibleHeight <= 0) return 0;

      // 元素的总面积
      const totalArea = rect.width * rect.height;
      // 可见面积
      const visibleArea = visibleWidth * visibleHeight;

      // 返回百分比，四舍五入到整数
      return Math.round((visibleArea / totalArea) * 100);
    },
  }
};
</script>
